import { render } from "./LayoutOverviewEnergi.vue?vue&type=template&id=f089de04&scoped=true"
import script from "./LayoutOverviewEnergi.vue?vue&type=script&lang=js"
export * from "./LayoutOverviewEnergi.vue?vue&type=script&lang=js"

import "./LayoutOverviewEnergi.vue?vue&type=style&index=0&id=f089de04&lang=scss&scoped=true"
import "./LayoutOverviewEnergi.vue?vue&type=style&index=1&id=f089de04&lang=scss"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f089de04"]])

export default __exports__